import { ajax } from "@/plugins/ajax";

export default {
  namespaced: true,
  state: {
    list: []
  },
  getters: {
    list: state => state.list
  },
  actions: {
    update({ commit, dispatch }, model) {
      return ajax.put("CMS/api/Comments", model).then(() => {});
    }
  },
  mutations: {
    setList(state, data) {
      state.list = data;
    }
  }
};
